import {
  lesedi_dashboard_id,
  ekuphumleni_dashboard_id,
  ganyesa_dashboard_id,
  thembokwezi_dashboard_id,
  amsterdam_dashboard_id,
  madadeni_dashboard_id,
  aliwal_north_dashboard_id,
  rustenburg_dashboard_id,
  ngqamakhwe_dashboard_id,
  mkhondo_dashboard_id,
  erica_dashboard_id
} from '@/config/dashboardIds';
import { LIVE_FEEDS } from '@/config/live_feed_urls';

export default function getTilesConfiguration() {
  const SERVICE_PROVIDER_LIST = [
    { name: "City Power", category: "Electricity", phone: "086 000 7788", icon: "bi bi-lightning-charge-fill" },
    { name: "Johannesburg Water", category: "Water & Sanitation", phone: "011 688 2500", icon: "bi bi-droplet-fill" },
    { name: "Afrox Gas", category: "Gas Supply", phone: "086 022 3300", icon: "bi bi-fire" },
    { name: "Vumatel", category: "Fibre Internet", phone: "087 820 9000", icon: "bi bi-wifi" },
    { name: "Fidelity ADT", category: "Security Response", phone: "086 013 4354", icon: "bi bi-shield-lock-fill" },
    { name: "Vuma Cam", category: "CCTV Monitoring", phone: "010 500 3000", icon: "bi bi-camera-video-fill" },
    { name: "Engen Fleet", category: "Diesel Supply", phone: "086 010 1010", icon: "bi bi-truck" }
  ];

  const MALL_OF_AFRICA_COORDINATES = { lat: -26.015085, lng: 28.1073946696504 };

  const tiles = [
    {
      id: 'Centurion Campus',
      title: 'Centurion Campus',
      stats: 'Energy Efficiency 92%',
      description: 'Shopping Centre',
      trend: '+3.8%',
      dashboardId: thembokwezi_dashboard_id,
      coordinates: MALL_OF_AFRICA_COORDINATES,
      propertyOverview: { size: '6,468 m²', occupancy: '91%', description: 'Shopping Centre' },
      crimeStats: {
        precinct: "Philippi East",
        stationContact: "021 370 1000",
        crimeIndex: "High",
        periodIncrease: "7% increase from Jun 2025 to Sept 2025",
        incidentSummary: [
          { category: "Property Crime", count: 14, trend: "+8%" },
          { category: "Theft from Vehicle", count: 9, trend: "+12%" },
          { category: "Assault", count: 6, trend: "+5%" },
          { category: "Burglary", count: 4, trend: "+3%" }
        ],
        lastUpdated: "2025-09-30",
        communityForumLink: "https://philippi-community-watch.co.za"
      },
      tileCards: [
        {
          id: "Centurion Campus-management-contacts",
          title: "On-Site Team Members",
          type: "details",
          contacts: [
            {
              full_name: "Mzwandile",
              role: "Centre Manager",
              status: "on-site",               // on-site | break | off-site
              hours: "Mon-Fri 8am-5pm",
              phone: "082 882 3507",
              email: "N/A",
              address: "shop no 20 thembokhwezi square, Swartklip Rd, Mandalay, Cape Town, 7783",
              website: "N/A"
            },
            {
              full_name: "Security Control Room",
              role: "Security Manager",
              status: "on-site",
              hours: "24/7",
              phone: "N/A",
              email: "N/A",
              address: "shop no 20 thembokhwezi square, Swartklip Rd, Mandalay, Cape Town, 7783",
              website: "N/A"
            },
            {
              full_name: "Facilities Office",
              role: "Facilities Manager",
              status: "on-site",
              hours: "Mon-Fri 8am-5pm",
              phone: "N/A",
              email: "N/A",
              address: "shop no 20 thembokhwezi square, Swartklip Rd, Mandalay, Cape Town, 7783",
              website: "N/A"
            },
            {
              full_name: "After-Hours Emergency",
              role: "Emergency Contact",
              status: "off-site",
              hours: "After Hours",
              phone: "N/A",
              email: "N/A",
              address: "shop no 20 thembokhwezi square, Swartklip Rd, Mandalay, Cape Town, 7783",
              website: "N/A"
            }
          ]
        },
        {
          id: 'Centurion Campus-emergency-contacts-map',
          title: 'Emergency Contacts & Location',
          type: 'emergency-map',
          locationName: 'Centurion Campus',
          coordinates: MALL_OF_AFRICA_COORDINATES
        },
        {
          id: 'Centurion Campus-service-providers',
          title: 'Service Providers',
          type: 'service-providers',
          providers: SERVICE_PROVIDER_LIST
        }
      ]
    },
    {
      id: 'Midrand Service Hub (Live)',
      title: 'Midrand Service Hub',
      stats: 'Energy Efficiency 97%',
      description: 'Shopping Centre',
      trend: '+4.5%',
      dashboardId: erica_dashboard_id,
      coordinates: MALL_OF_AFRICA_COORDINATES,
      liveFeed: LIVE_FEEDS.midrand_service_hub,
      propertyOverview: { size: '5,830 mÂ²', occupancy: '95%', description: 'Shopping Centre' },
      teamContacts: [
        { initials: "SM", name: "Sarah Mbatha", role: "Centre Manager", status: "on-site" },
        { initials: "TN", name: "Thabo Nkosi", role: "Security Manager", status: "on-site" },
        { initials: "LV", name: "Linda van der Merwe", role: "Facilities Manager", status: "break" },
        { initials: "PM", name: "Peter Molefe", role: "IT Systems Manager", status: "on-site" }
      ],
      recentDocuments: [
        { title: "Q4 2025 Performance Report â€“ Erica", updated: "2 hours ago", size: "2.4 MB", icon: "bi bi-file-earmark-pdf-fill" },
        { title: "Energy Consumption Analysis â€“ Erica", updated: "yesterday", size: "1.8 MB", icon: "bi bi-file-earmark-excel-fill" },
        { title: "Incident Report â€“ Nov 28 (Erica)", updated: "3 days ago", size: "856 KB", icon: "bi bi-file-earmark-word-fill" },
        { title: "Maintenance Schedule â€“ December (Erica)", updated: "1 week ago", size: "3.2 MB", icon: "bi bi-file-earmark-pdf-fill" }
      ],
      shiftSchedule: [
        { label: "Security â€“ Morning Shift", time: "06:00 â€“ 14:00", personnel: 12 },
        { label: "Cleaning â€“ Day Shift", time: "08:00 â€“ 16:00", personnel: 18 },
        { label: "Security â€“ Evening Shift", time: "14:00 â€“ 22:00", personnel: 14 },
        { label: "Maintenance â€“ Night Shift", time: "22:00 â€“ 06:00", personnel: 8 }
      ],
      tileCards: [
        {
          id: 'Erica-management-contacts',
          title: 'Management Contacts',
          type: 'details',
          details: {
            address: 'Ground Floor, 35 Ferguson Rd, Illovo, Sandton, 2196',
            hours: 'Mzwandile: Mon-Fri 9am-6pm',
            website: 'www.erica-shopping.co.za',
            phone: '082 882 3507',
            email: 'management@erica.co.za'
          }
        },
        {
          id: 'Erica-emergency-contacts-map',
          title: 'Emergency Contacts & Location',
          type: 'emergency-map',
          locationName: 'Midrand Service Hub',
          coordinates: MALL_OF_AFRICA_COORDINATES,
          liveFeed: LIVE_FEEDS.midrand_service_hub
        },
        {
          id: 'Erica-service-providers',
          title: 'Service Providers',
          type: 'service-providers',
          providers: SERVICE_PROVIDER_LIST
        }
      ]
    },
    {
      id: 'Bellville Data Centre',
      title: 'Bellville Data Centre',
      stats: 'Energy Efficiency 85%',
      description: 'Shopping Centre',
      trend: '+2.1%',
      dashboardId: lesedi_dashboard_id,
      coordinates: MALL_OF_AFRICA_COORDINATES,
      propertyOverview: { size: '7,360 m²', occupancy: '92%', description: 'Shopping Centre' },
      crimeStats: {
        precinct: "Vosloorus Precinct",
        stationContact: "011 861 6600",
        crimeIndex: "High",
        periodIncrease: "14% increase from Jun 2025 to Sept 2025",
        incidentSummary: [
          { category: "Property Crime", count: 12, trend: "-5%" },
          { category: "Theft from Vehicle", count: 8, trend: "+10%" },
          { category: "Assault", count: 4, trend: "0%" },
          { category: "Burglary", count: 3, trend: "-15%" }
        ],
        lastUpdated: "2025-09-30",
        communityForumLink: "https://forum.vosloorus-community.co.za"
      },
      tileCards: [
        {
          id: "Lesedi-management-contacts",
          title: "On-Site Team Members",
          type: "details",
          contacts: [
            {
              full_name: "Phindile Tsotetsi",
              role: "Centre Manager",
              status: "on-site",                 // on-site | break | off-site
              hours: "Mon-Fri 8am-5pm",
              phone: "066 136 7815",
              email: "N/A",
              address: "Mc Botha Dr, Vosloorus, Johannesburg, 1475",
              website: "N/A"
            },
            {
              full_name: "Thabo Nkosi",
              role: "Security Manager",
              status: "on-site",
              hours: "24/7",
              phone: "011 000 0000",
              email: "security@lesedi.co.za",
              address: "Mc Botha Dr, Vosloorus, Johannesburg, 1475",
              website: "N/A"
            }
          ]
        },
        {
          id: 'Lesedi-emergency-contacts-map',
          title: 'Emergency Contacts & Location',
          type: 'emergency-map',
          locationName: 'Bellville Data Centre',
          coordinates: MALL_OF_AFRICA_COORDINATES
        },
        {
          id: 'Lesedi-service-providers',
          title: 'Service Providers',
          type: 'service-providers',
          providers: SERVICE_PROVIDER_LIST
        }
      ]
    },
    {
      id: 'Durban Operations Centre',
      title: 'Durban Operations Centre',
      stats: 'Energy Efficiency 93%',
      description: 'Retail Centre',
      trend: '+3.1%',
      dashboardId: ekuphumleni_dashboard_id,
      coordinates: MALL_OF_AFRICA_COORDINATES,
      propertyOverview: { size: '6,468 m²', occupancy: '98%', description: 'Retail Centre' },
      crimeStats: {
        precinct: "Kenton-On-Sea",
        stationContact: "046 648 1234",
        crimeIndex: "Medium",
        periodIncrease: "12% decrease from Jun 2025 to Sept 2025",
        incidentSummary: [
          { category: "Property Crime", count: 6, trend: "-15%" },
          { category: "Theft from Vehicle", count: 3, trend: "-20%" },
          { category: "Assault", count: 2, trend: "-10%" },
          { category: "Burglary", count: 1, trend: "-25%" }
        ],
        lastUpdated: "2025-09-30",
        communityForumLink: "https://kentonsea-community.co.za"
      },
      tileCards: [
        {
          id: "Ekuphumleni-management-contacts",
          title: "On-Site Team Members",
          type: "details",
          contacts: [
            {
              full_name: "Zimkihita",
              role: "Centre Manager",
              status: "on-site",                 // on-site | break | off-site
              hours: "Mon-Fri 8am-5pm",
              phone: "083 246 3531",
              email: "N/A",
              address: "1355 Kariega Rd, Kenton-on-Sea, 6191",
              website: "N/A"
            },
            {
              full_name: "Security Control Room",
              role: "Security Manager",
              status: "on-site",
              hours: "24/7",
              phone: "N/A",
              email: "N/A",
              address: "1355 Kariega Rd, Kenton-on-Sea, 6191",
              website: "N/A"
            }
          ]
        },
        {
          id: 'Ekuphumleni-emergency-contacts-map',
          title: 'Emergency Contacts & Location',
          type: 'emergency-map',
          locationName: 'Durban Operations Centre',
          coordinates: MALL_OF_AFRICA_COORDINATES
        },
        {
          id: 'Ekuphumleni-service-providers',
          title: 'Service Providers',
          type: 'service-providers',
          providers: SERVICE_PROVIDER_LIST
        }
      ]
    },
    {
      id: 'Gqeberha Network Hub',
      title: 'Gqeberha Network Hub',
      stats: 'Energy Efficiency 88%',
      description: 'Shopping Centre',
      trend: '+2.8%',
      dashboardId: ganyesa_dashboard_id,
      coordinates: MALL_OF_AFRICA_COORDINATES,
      propertyOverview: { size: '5,200 m²', occupancy: '85%', description: 'Shopping Centre' },
      crimeStats: {
        precinct: "Gqeberha Precinct",
        stationContact: "053 998 2000",
        crimeIndex: "Medium",
        periodIncrease: "6% increase from Jun 2025 to Sept 2025",
        incidentSummary: [
          { category: "Property Crime", count: 8, trend: "+2%" },
          { category: "Theft from Vehicle", count: 5, trend: "+8%" },
          { category: "Assault", count: 3, trend: "-5%" },
          { category: "Burglary", count: 2, trend: "0%" }
        ],
        lastUpdated: "2025-09-30",
        communityForumLink: "https://ganyesa-community-safety.co.za"
      },
      tileCards: [
        {
          id: "Gqeberha Network Hub-management-contacts",
          title: "On-Site Team Members",
          type: "details",
          contacts: [
            {
              full_name: "Tlhaloso",
              role: "Centre Manager",
              status: "on-site",              // on-site | break | off-site
              hours: "Mon-Fri 8am-5pm",
              phone: "053 998 1234",
              email: "N/A",
              address: "Shop No 9, Makwati Centre, Gqeberha Network Hub, 8613",
              website: "N/A"
            },
            {
              full_name: "Security Control Room",
              role: "Security Manager",
              status: "on-site",
              hours: "24/7",
              phone: "N/A",
              email: "N/A",
              address: "Shop No 9, Makwati Centre, Gqeberha Network Hub, 8613",
              website: "N/A"
            },
            {
              full_name: "Facilities Office",
              role: "Facilities Manager",
              status: "on-site",
              hours: "Mon-Fri 8am-5pm",
              phone: "N/A",
              email: "N/A",
              address: "Shop No 9, Makwati Centre, Gqeberha Network Hub, 8613",
              website: "N/A"
            },
            {
              full_name: "After-Hours Emergency",
              role: "Emergency Contact",
              status: "off-site",
              hours: "After Hours",
              phone: "N/A",
              email: "N/A",
              address: "Shop No 9, Makwati Centre, Gqeberha Network Hub, 8613",
              website: "N/A"
            }
          ]
        },
        {
          id: 'Gqeberha Network Hub-emergency-contacts-map',
          title: 'Emergency Contacts & Location',
          type: 'emergency-map',
          locationName: 'Gqeberha Network Hub',
          coordinates: MALL_OF_AFRICA_COORDINATES
        },
        {
          id: 'Gqeberha Network Hub-service-providers',
          title: 'Service Providers',
          type: 'service-providers',
          providers: SERVICE_PROVIDER_LIST
        }
      ]
    },
    {
      id: 'Bloemfontein Service Centre',
      title: 'Bloemfontein Service Centre',
      stats: 'Energy Efficiency 90%',
      description: 'Shopping Centre',
      trend: '+3.5%',
      dashboardId: amsterdam_dashboard_id,
      coordinates: MALL_OF_AFRICA_COORDINATES,
      propertyOverview: { size: '4,800 m²', occupancy: '88%', description: 'Shopping Centre' },
      tileCards: [
        {
          id: 'Bloemfontein Service Centre-management-contacts',
          title: 'Management Contacts',
          type: 'details',
          details: {
            address: 'Bloemfontein Service Centre, Bloemfontein Service Centre, North West',
            hours: 'Mduduzi: Mon-Fri 8am-5pm',
            website: 'N/A',
            phone: '071 081 0963',
            email: 'N/A'
          }
        },
        {
          id: 'Bloemfontein Service Centre-emergency-contacts-map',
          title: 'Emergency Contacts & Location',
          type: 'emergency-map',
          locationName: 'Bloemfontein Service Centre',
          coordinates: MALL_OF_AFRICA_COORDINATES
        },
        {
          id: 'Bloemfontein Service Centre-service-providers',
          title: 'Service Providers',
          type: 'service-providers',
          providers: SERVICE_PROVIDER_LIST
        }
      ]
    },
    {
      id: 'Nelspruit Field Office',
      title: 'Nelspruit Field Office',
      stats: 'Energy Efficiency 82%',
      description: 'Shopping Centre',
      trend: '+1.8%',
      dashboardId: madadeni_dashboard_id,
      coordinates: MALL_OF_AFRICA_COORDINATES,
      propertyOverview: { size: '6,200 m²', occupancy: '80%', description: 'Shopping Centre' },
      tileCards: [
        {
          id: 'Nelspruit Field Office-management-contacts',
          title: 'Management Contacts',
          type: 'details',
          details: {
            address: 'Nelspruit Field Office, Nelspruit Field Office, KwaZulu-Natal',
            hours: 'Percy: Mon-Fri 8am-5pm',
            website: 'www.madadeni-shopping.co.za',
            phone: '034 312 3456',
            email: 'management@madadeni.co.za'
          }
        },
        {
          id: 'Nelspruit Field Office-emergency-contacts-map',
          title: 'Emergency Contacts & Location',
          type: 'emergency-map',
          locationName: 'Nelspruit Field Office',
          coordinates: MALL_OF_AFRICA_COORDINATES
        },
        {
          id: 'Nelspruit Field Office-service-providers',
          title: 'Service Providers',
          type: 'service-providers',
          providers: SERVICE_PROVIDER_LIST
        }
      ]
    },
    {
      id: 'Polokwane Support Centre',
      title: 'Polokwane Support Centre',
      stats: 'Energy Efficiency 89%',
      description: 'Shopping Centre',
      trend: '+3.2%',
      dashboardId: aliwal_north_dashboard_id,
      coordinates: MALL_OF_AFRICA_COORDINATES,
      propertyOverview: { size: '5,500 m²', occupancy: '87%', description: 'Shopping Centre' },
      tileCards: [
        {
          id: 'Polokwane Support Centre-management-contacts',
          title: 'Management Contacts',
          type: 'details',
          details: {
            address: 'Polokwane Support Centre, Polokwane Support Centre, Eastern Cape',
            hours: 'Monday-Friday: 8am-5pm',
            website: 'www.aliwalnorth-shopping.co.za',
            phone: '051 633 1234',
            email: 'management@aliwalnorth.co.za'
          }
        },
        {
          id: 'Polokwane Support Centre-emergency-contacts-map',
          title: 'Emergency Contacts & Location',
          type: 'emergency-map',
          locationName: 'Polokwane Support Centre',
          coordinates: MALL_OF_AFRICA_COORDINATES
        },
        {
          id: 'Polokwane Support Centre-service-providers',
          title: 'Service Providers',
          type: 'service-providers',
          providers: SERVICE_PROVIDER_LIST
        }
      ]
    },
    {
      id: 'Platinum Belt Connectivity Hub',
      title: 'Platinum Belt Connectivity Hub',
      stats: 'Energy Efficiency 94%',
      description: 'Shopping Centre',
      trend: '+4.2%',
      dashboardId: rustenburg_dashboard_id,
      coordinates: MALL_OF_AFRICA_COORDINATES,
      propertyOverview: { size: '8,500 m²', occupancy: '96%', description: 'Shopping Centre' },
      tileCards: [
        {
          id: 'Platinum Belt Connectivity Hub-management-contacts',
          title: 'Management Contacts',
          type: 'details',
          details: {
            address: 'Platinum Belt Connectivity Hub, Platinum Belt Connectivity Hub, North West',
            hours: 'Monday-Friday: 8am-5pm',
            website: 'www.rustenburg-shopping.co.za',
            phone: '014 597 1234',
            email: 'management@rustenburg.co.za'
          }
        },
        {
          id: 'Platinum Belt Connectivity Hub-emergency-contacts-map',
          title: 'Emergency Contacts & Location',
          type: 'emergency-map',
          locationName: 'Platinum Belt Connectivity Hub',
          coordinates: MALL_OF_AFRICA_COORDINATES
        },
        {
          id: 'Platinum Belt Connectivity Hub-service-providers',
          title: 'Service Providers',
          type: 'service-providers',
          providers: SERVICE_PROVIDER_LIST
        }
      ]
    },
    {
      id: 'East London Service Desk',
      title: 'East London Service Desk',
      stats: 'Energy Efficiency 86%',
      description: 'Shopping Centre',
      trend: '+2.4%',
      dashboardId: ngqamakhwe_dashboard_id,
      coordinates: MALL_OF_AFRICA_COORDINATES,
      propertyOverview: { size: '4,300 m²', occupancy: '83%', description: 'Shopping Centre' },
      tileCards: [
        {
          id: 'East London Service Desk-management-contacts',
          title: 'Management Contacts',
          type: 'details',
          details: {
            address: 'East London Service Desk, East London Service Desk, Eastern Cape',
            hours: 'Monday-Friday: 8am-5pm',
            website: 'www.ngqamakhwe-shopping.co.za',
            phone: '047 498 1234',
            email: 'management@ngqamakhwe.co.za'
          }
        },
        {
          id: 'East London Service Desk-emergency-contacts-map',
          title: 'Emergency Contacts & Location',
          type: 'emergency-map',
          locationName: 'East London Service Desk',
          coordinates: MALL_OF_AFRICA_COORDINATES
        },
        {
          id: 'East London Service Desk-service-providers',
          title: 'Service Providers',
          type: 'service-providers',
          providers: SERVICE_PROVIDER_LIST
        }
      ]
    },
    {
      id: 'Mbombela Data Node',
      title: 'Mbombela Data Node',
      stats: 'Energy Efficiency 91%',
      description: 'Shopping Centre',
      trend: '+3.6%',
      dashboardId: mkhondo_dashboard_id,
      coordinates: MALL_OF_AFRICA_COORDINATES,
      propertyOverview: { size: '7,100 m²', occupancy: '90%', description: 'Shopping Centre' },
      tileCards: [
        {
          id: 'Mbombela Data Node-management-contacts',
          title: 'Management Contacts',
          type: 'details',
          details: {
            address: 'Mbombela Data Node, Piet Retief, Mpumalanga',
            hours: 'Sabrina Nel: Mon-Fri 8am-5pm',
            website: 'www.mkhondo-shopping.co.za',
            phone: '082 694 1884',
            email: 'management@mkhondo.co.za'
          }
        },
        {
          id: 'Mbombela Data Node-emergency-contacts-map',
          title: 'Emergency Contacts & Location',
          type: 'emergency-map',
          locationName: 'Mbombela Data Node',
          coordinates: MALL_OF_AFRICA_COORDINATES
        },
        {
          id: 'Mbombela Data Node-service-providers',
          title: 'Service Providers',
          type: 'service-providers',
          providers: SERVICE_PROVIDER_LIST
        }
      ]
    },

  ];

  [tiles[0], tiles[1]] = [tiles[1], tiles[0]];

  return tiles;
}
